import { defineAsyncComponent } from 'vue'

// 大屏编辑页
// export const DataVEditPage = () => import('./src/views/big-screen-edit-page/index.vue')
export const DataVEditPage = () => import('./src/views/canvas-dashboard/index.vue')
// 属性区
export * from './src/components/attr-comp/attr-comp'
